import api from './api';

export interface FunctionPromptMapping {
  prompt_file: string;
  description: string;
  requires_markdown: boolean;
  label_fr?: string;
  label_en?: string;
}

export interface FunctionPromptData {
  function_name: string;
  label_fr?: string;
  label_en?: string;
  prompt_content: string;
  description: string;
  requires_markdown: boolean;
}

export const derivativesService = {
  /**
   * Get all function-to-prompt mappings
   */
  async getFunctionPromptsMapping(): Promise<Record<string, FunctionPromptMapping>> {
    const response = await api.get<{ mappings: Record<string, FunctionPromptMapping> }>(
      '/knowledge-bases/function-prompts-mapping'
    );
    return response.data.mappings;
  },

  /**
   * Save a new function with its prompt file
   */
  async saveFunctionPrompt(data: FunctionPromptData): Promise<unknown> {
    const response = await api.post<unknown>(
      '/knowledge-bases/function-prompt',
      data
    );
    return response.data;
  },

  /**
   * Get current derivatives configuration
   */
  async getDerivativesConfig(): Promise<{ functions: string[]; content: string }> {
    const response = await api.get<{ functions: string[]; content: string }>(
      '/knowledge-bases/derivatives-config'
    );
    return response.data;
  },

  /**
   * Update derivatives configuration
   */
  async updateDerivativesConfig(content: string): Promise<unknown> {
    const response = await api.post<unknown>(
      '/knowledge-bases/derivatives-config',
      { content }
    );
    return response.data;
  }
};
